// USA
export const locale = {
	lang: 'ar',
	data: {
		TRANSLATOR: {
			SELECT: 'أختر لغتك',
			NAME: 'name_ar',
		},
		MENU: {
			NEW: 'new',
			ACTIONS: 'Actions',
			CREATE_POST: 'Create New Post',
			PAGES: 'Pages',
			FEATURES: 'Features',
			APPS: 'Apps',
			DASHBOARD: 'لوحة المعلومات',
		},
		DASHBOARD:{
         TOTAL_AREAS:'مجموع المناطق',
         TOTAL_COMPANIES:'مجموع الشركات',
         TOTAL_CARS:'مجموع السيارات',
		 TOTAL_AMOUNT:'اجمالي البلغ',
		 MOBILE:'الهاتف الخلوي',
		 FULL_NAME:'الاسم',
		 COMPANY_NAME:'اسم الشركة',
		 RECENT_DRIVERS:'أخر السائقين',
		 RECENT_CARS:'أخر السيارات',
		 CAR_PLATE:'لوحة السيارة',
		 COLOR_NAME:'اللون',
		 COLOR_NAME_EN:'name_ar',
		},
		USER_PROFILE:{
			HI:'مرحبا،'
		},
		AUTH: {
			GENERAL: {
				OR: 'أو',
				SUBMIT_BUTTON: 'ارسال',
				NO_ACCOUNT: 'لا تملك حساب بعد؟',
				SIGNUP_BUTTON: 'تسجيل الدخول',
				FORGOT_BUTTON: 'نسيت كلمة السر',
				BACK_BUTTON: 'رجوع',
				PRIVACY: 'الخصوصية',
				LEGAL: 'الحقوق',
				CONTACT: 'تواصل',
				SIGNOUT: 'تسجيل الخروج',
				RIGHTS:'جميع الحقوق محفوظة 2020'
			},
			LOGIN: {
				TITLE: 'تسجيل الدخول إلى حسابك',
				BUTTON: 'تسجيل الدخول',
				HELLO:'مرحبا',
				LOGIN_DATA:'إملاء بيانات تسجيل الدخول',
			},
			FORGOT: {
				TITLE: 'هل نسيت كلمة المرور؟',
				DESC: 'أدخل رقم الهاتف لإعادة تعيين كلمة السر',
				SUCCESS: 'تم إعادة تعيين حسابك بنجاح.'
			},
			REGISTER: {
				TITLE: 'Sign Up',
				DESC: 'Enter your details to create your account',
				SUCCESS: 'Your account has been successfuly registered.'
			},
			INPUT: {
				EMAIL: 'البريد الإلتكروني',
				MOBILE: 'الهاتف الخلوي',
				EMPLOYEE_NUMBER: 'رقم الموظف',
				FULLNAME: 'الاسم كامل',
				PASSWORD: 'كلمة السر',
				CONFIRM_PASSWORD: 'إعادة كلمة السر',
				USERNAME: 'اسم المستخدم',
				LOGIN_BY:':تسجيل الدخول بإستخدام'
			},
			VALIDATION: {
				INVALID: '{{name}} غير صحيح',
				REQUIRED: 'مطلوب {{name}}',
				MIN_LENGTH: '{{name}} minimum length is {{min}}',
				AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
				NOT_FOUND: 'The requested {{name}} is not found',
				INVALID_LOGIN: 'The login detail is incorrect',
				REQUIRED_FIELD: 'هذا الحقل مطلوب',
				MIN_LENGTH_FIELD: 'Minimum field length:',
				MAX_LENGTH_FIELD: 'Maximum field length:',
				INVALID_FIELD: 'المدخل غير صحيح',
			}
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: 'Selected records count: ',
				ALL: 'All',
				SUSPENDED: 'Suspended',
				ACTIVE: 'Active',
				FILTER: 'Filter',
				BY_STATUS: 'by Status',
				BY_TYPE: 'by Type',
				BUSINESS: 'Business',
				INDIVIDUAL: 'Individual',
				SEARCH: 'Search',
				IN_ALL_FIELDS: 'in all fields'
			},
			ECOMMERCE: 'eCommerce',
			CUSTOMERS: {
				CUSTOMERS: 'Customers',
				CUSTOMERS_LIST: 'Customers list',
				NEW_CUSTOMER: 'New Customer',
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: 'Customer Delete',
					DESCRIPTION: 'Are you sure to permanently delete this customer?',
					WAIT_DESCRIPTION: 'Customer is deleting...',
					MESSAGE: 'Customer has been deleted'
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: 'Customers Delete',
					DESCRIPTION: 'Are you sure to permanently delete selected customers?',
					WAIT_DESCRIPTION: 'Customers are deleting...',
					MESSAGE: 'Selected customers have been deleted'
				},
				UPDATE_STATUS: {
					TITLE: 'Status has been updated for selected customers',
					MESSAGE: 'Selected customers status have successfully been updated'
				},
				EDIT: {
					UPDATE_MESSAGE: 'Customer has been updated',
					ADD_MESSAGE: 'Customer has been created'
				}
			}
		},
	COMPANY_MANAGEMENT:{
		COMPANIES:{
			TITLE: 'الشركات',
			COMPANY_LIST:{
				TITLE: 'قائمة الشركات',
				ADD_NEW_COMPANY: 'إضافة شركة جديدة',
				COMPANY_INFORMATION: 'معلومات الشركة',
				NEED_TO_ADD_ONE_AREA: 'يجب أختيار منطقة واحدة على الأقل',
				TABLE: {
					ACCEPT_BALANCE_PAYMENT: 'الدفع من رصيد الشركة',
					COMPANY_NAME: 'اسم الشركة',
					AREA: 'المنطقة',
					ON: 'فعال',
					OFF: 'غير فعال',
					TICKET_FEES: 'سعر التذكرة'
				}
			},
			COMPANY_CARS:{
				TITLE: 'أنواع السيارات',
				ADD_NEW_CAR: 'أضافة نوع سيارة',
				COMPANY_CAR_INFORMATION: 'معلومات نوع السيارة',
				EDIT_COMPANY_CAR: 'تعديل نوع السيارة',
				SEARCH_COMPANY_CAR: 'البحث في أنواع السيارات',
				SELECT_COMPANY: 'اختر شركة',
				TABLE: {
					NAME_EN: 'الاسم باللغة الإنجليزية',
					NAME_AR: 'الاسم باللغة العربية',
					PRICE_PER_KM: 'السعر/كم',
					COMPANY: 'الشركة',
					SELECT_COMPANY: 'اختر شركة',
					COMPANY_NAME: 'اسم الشركة',
				}
			},
			CARS:{
				TITLE: 'السيارات',
				ADD_NEW_CAR: 'أضافة سيارة جديدة',
				CAR_INFORMATION: 'معلومات السيارة',
				EDIT_COMPANY_CAR: 'تعديل السيارة',
				SEARCH_COMPANY_CAR: 'البحث في السيارات',
				DRIVER_LIST: 'قائمة السائقين',
				SELECT_COMPANY: 'اختر شركة',
				TABLE: {
					PLATE_NUMBER: 'رقم اللوحة',
					CAR_TYPE: 'نوع السيارة',
					CAR_MODEL: 'موديل السيارة',
					CAR_COLOR: 'لون السيارة',
					CAR_NAME: 'اسم السيارة',
					NAME_EN: 'اسم السيارة باللغة الإنجليزية',
					NAME_AR: 'اسم السيارة باللغة العربية',
					COMPANY: 'الشركة',
					SELECT_COMPANY: 'أختر شركة',
					COMPANY_NAME: 'اسم الشركة',
					MANFACTURER_ID: 'الشركة المصنعة',
					MODEL_YEAR: 'سنة الانتاج'
				}
			},
			DRIVERS:{
				DRIVER_LIST: 'قائمة السائقين',
				TITLE: 'السائقين',
				ADD_NEW_DRIVER: 'إضافة سائق جديد',
				DRIVER_INFORMATION: 'معلومات السائق',
				EDIT_DRIVER: 'تعديل معلومات السائق',
				SEARCH_COMPANY_DRIVER: 'البحث في السائقين',
				SELECT_COMPANY: 'أختر شركة',
				SELECT_CAR: 'أختر سيارة',
				CAR_LIST: 'قائمة السيارات',
				DRIVER_CARS: 'سيارات السائق',
				TABLE: {
					CAR_TYPE: 'نوع السيارة',
					CAR_MODEL: 'موديل السيارة',
					COMPANY: 'الشركة',
					COMPANY_NAME: 'اسم الشركة',
					MOBILE: 'رقم الجوال',
					NAME: 'الاسم بالكامل',
					AREA: 'المنطقة',
					PASSWORD: 'كلمة السر'
				}
			}
		},
		COMPANY_BALANCE: {
			TITLE: 'رصيد الشركات',
			COMPANY_BALANCE_LIST: {
				TITLE: 'قائمة رصيد الشركة',
				ADD_NEW_COMPANY_BALANCE: 'إضافة رصيد',
				COMPANY_TOTAL_BALANCE: 'رصيد الشركة الإجمالي',
				TABLE: {
					AMOUNT: 'المبلغ',
					REFERENCE_ID: 'معرف الفاتورة'
				}
			}
		},
		PLACES:{
			TITLE: 'الأماكن',
			PLACE_LIST:{
				TITLE: 'قائمة الأماكن',
				CAR_TYPE_PRICE: 'أسعار أنواع السيارات',
				TABLE:{
					NAME: 'الاسم',
					NAME_AR: 'الاسم باللغة العربية',
					NAME_EN: 'الاسم باللغة الانجليزية',
					LOCATION: 'الموقع',
					PLACE_TYPE: 'نوع المكان',
					ADDRESS_AR: 'العنوان بالعربي',
					ADDRESS_EN: 'العنوان بالإنجليزي',
				}
			}
		},
		},
		AREA_MANAGEMENT:{
			AREAS:{
				TITLE: 'المناطق',
				AREA_LIST:{
					TITLE: 'قائمة المناطق',
					TABLE:{
						AREA_NAME: 'الاسم',
						LOCATION: 'الموقع',
						AREA_NAME_AR: 'الاسم باللغة العربية',
						AREA_NAME_EN: 'الاسم باللغة الانجليزية',
						AREA_ID: 'المعرف'
					}
				}
			}
		},
		LOOKUP_MANAGEMENT:{
			TITLE:'إدارة ثوابت النظام',
			COLOR:{
				TITLE: 'ألوان السيارات',
				COLOR_LIST:{
					TITLE: 'قائمة ألوان السيارات',
					TABLE:{
						COLOR_NAME: 'الاسم',
						COLOR_NAME_AR: 'الاسم باللغة العربية',
						COLOR_NAME_EN: 'الاسم باللغة الانجليزية',
						COLOR_ID: 'المعرف'
					}
				}
			},
			PLACE_TYPES:{
				TITLE: 'أنواع الأماكن',
				PLACE_TYPES_LIST:{
					TITLE: 'قائمة أنواع الأماكن',
					TABLE:{
						NAME: 'الاسم',
						NAME_AR: 'الاسم باللغة العربية',
						NAME_EN: 'الاسم باللغة الانجليزية',
						ID: 'المعرف'
					}
				}
			},
			MODEL:{
				TITLE: 'موديل السيارات',
				MODEL_LIST:{
					TITLE: 'قائمة موديلات السيارات',
					TABLE:{
						MODEL_NAME: 'الاسم',
						MANUFACTURER_NAME: 'اسم الشركة المصنعة',
						MODEL_NAME_AR: 'الاسم باللغة العربية',
						MODEL_NAME_EN: 'الاسم باللغة الانجليزية',
						MODEL_ID: 'المعرف'
					}
				}
			},
			MANUFACTURER:{
				TITLE: 'الشركات المصنعة',
				MANUFACTURER_LIST:{
					TITLE: 'قائمة الشركات المصنعة',
					TABLE:{
						MANUFACTURER_NAME: 'الاسم',
						MANUFACTURER_NAME_AR: 'الاسم باللغة العربية',
						MANUFACTURER_NAME_EN: 'الاسم باللغة الانجليزية',
						MANUFACTURER_ID: 'المعرف'
					}
				}
			}
		},
		QUEUE_MANAGEMENT:{
			BARRIER:{
				TITLE: 'البوابات',
				BARRIER_LIST:{
					TITLE: 'قائمة البوابات',
					TABLE:{
						BARRIER_NAME: 'الاسم',
						NAME_AR: 'الاسم باللغة العربية',
						NAME_EN: 'الاسم باللغة الانجليزية',
						BARRIER_ID: 'المعرف'
					}
				}
			},
			QUEUES:{
				TITLE: 'طابور',
				QUEUE_LIST:{
					TITLE: 'قائمة الطابور',
					TABLE:{
						QUEUE_NAME: 'اسم الطابور',
						LOCATION: 'الموقع',
						AREA_NAME: 'اسم المنطقة',
						COMPANY_NAME: 'اسم الشركة',
						ENTER_BARRIER_ID: 'بوابة الدخول',
						SELECT_ENTER_BARRIER_ID: 'اختر بوابة الدخول',
						EXIT_BARRIER_ID: 'بوابة الخروج',
						SELECT_EXIT_BARRIER_ID: 'اختر بوابة الخروج',
						SECOND_EXIT_BARRIER_ID: 'بوابة الخروج الثانية',
						SELECT_SECOND_EXIT_BARRIER_ID: 'اختر بوابة الخروج الثانية',
						COMPANY_NAME_SELECT: 'أختر شركة أخرى',
						CAPACITY: 'السعة',
						REQUEST_MAX_DURATION: 'الحد الأقصى للوصول للبوابة (دقيقة)',
						CAPACITY_COMPANY_CAR_TYPES: 'سعة أنواع السيارات',
					}
				}
			},
			REQUESTS:{
				TITLE: 'طلبات السيارات',
				REQUEST_LIST:{
					TITLE: 'قائمة الطلبات',
					SELECT_STATUS: 'فلتر حسب الحالة',
					SEARCH_MOBILE: 'ابحث برقم الهاتف الخلوي',
					CREATE: 'انشاء طلب',
					COMPANY: 'الشركة',
					CAR_TYPE: 'نوع السيارة',
					MANUAL_REJECTED_ONLY: 'المرفوضة يدوياً فقط',
					TABLE:{
						QUEUE_NAME_FROM: 'من طابور',
						QUEUE_NAME_TO: 'إلى طابور',
						AREA_NAME: 'اسم المنطقة',
						STATUS_NAME: 'الحالة',
						DRIVER_NAME: 'اسم السائق',
						CAR: 'اسم السيارة',
						VIEWED: 'مشاهدة الطلب',
						ACCEPTED: ' قبول الطلب',
						REJECTED: 'رفض الطلب',
						TIMEOUT: 'انتهاء الوقت',
						MOBILE: 'رقم الموبايل',
						DETAILS: 'التفاصيل',
						REQUEST_DETAILS: 'تفاصيل طلب',
						DIFF_TIME: 'فرق الوقت',
						CAR_PLATE: 'لوحة السيارة',
					}
				}
			},
			LIVE_QUEUES:{
				TITLE: 'المسارات الحية',
				LIVE_QUEUES_LIST:{
					TITLE: 'قائمة المسارات الحية',
					TABLE:{
					}
				}
			}
		},
		SHIFT_MANAGEMENT:{
			SHIFTS:{
				TITLE: 'المناوبات',
				SHIFT_LIST:{
					TITLE: 'قائمة المناوبة',
					SELECT_CASHIER:'أختر كاشير',
					CASHIER:'اسم الكاشير',
					ALL_CASHIERS: 'الكل',
					TABLE:{
						START_DATE: 'تاريخ البداية',
						END_DATE: 'تاريخ النهاية',
						SHIFT_STATUS: 'حالة المناوبة',
						CLOSE_AMOUNT: 'مبلغ الإغلاق',
						DIFFERENCE: 'فارق المبلغ',
						TOTAL: 'المجموع',
						COMPAMY_AMOUNT: 'المدفوع من رصيد الشركة',
						DRIVER_AMOUNT: 'دفع من رصيد السائق',
						AMOUNT: 'المدفوع نقداً',
						CLOSED: 'مغلق',
						OPENED: 'مفتوح',
					}
				},
				PAYMENT_LIST:{
					TITLE: 'الدفعات',
					CANCELLED_FILTER_LABEL: 'حالة الدفع',
					CANCELLED_FILTER_ALL: 'الكل',
					CANCELLED_FILTER_CANCELLED: 'ملغاة فقط',
					CANCELLED_FILTER_NOT_CANCELLED: 'غير ملغاة',
					TABLE:{
					 PAYMENT_ID:'معرف الفاتورة',
					 REQUEST_ID:'معرف الطلب',
					 AREA_NAME:'المنطقة',
					 COMPANY_NAME:'الشركة',
					 CASHIER_NAME:'الكاشير',
					 DRIVER_NAME:'السائق',
					 CAR_NAME:'السيارة',
					 AMOUNT:'الكمية',
					 PAYMENT_METHOD:'طريقة الدفع',
					 COMPANY_PAY:'دفع الشركة',
					 MANUAL_PAY:'دفع نقدي',
					 DRIVER_PAY:'دفع من رصيد السائق',
					 CREATED_AT:'التاريخ'
					}
				}
			}
		},
		LIVE_QUEUE_STATISTICS:{
        TITLE: 'إحصائيات المسارات الحية',
        COUNT_TITLE: 'مجموع السيارات في المسارات الحية',
		CAR_COUNT_BY_AREA_TITLE: 'مجموع السيارات حسب المنطقة',
		ACCEPTED_REQUESTS_TITLE: 'الطلبات المقبولة',
		DRIVERS_REQUESTS_REJECTED_TITLE: 'قائمة السائقين للطلبات المرفوضة',
		LIVE_QUEUE_ACTIONS_TITLE: 'دخول / خروج',
		PAYMENT_TITLE: 'الدفعات',
		},
		COMMON:{
			ADD: 'إضافة',
			NEW: 'جديد',
			EDIT: 'تعديل',
			DELETE: 'حذف',
			PREVIOUS: 'السابق',
			BACK: 'عودة',
			SAVE: 'حفظ',
			SEND: 'ارسل',
			SAVE_EXIT: 'حفظ وخروج',
			SAVE_DUBLICATE: 'حفظ وتكرار',
			RESET:'مسح',
			OTHER:'آخر',
			OTHERS:'آخرين',
			SUCCESS: 'تمت العملية بنجاح!',
			DELET_CONFIRM: 'هل أنت متأكد؟',
			CANCEL: 'إلغاء',
			CLOSE: 'إغلاق',
			CONFIRM: 'موافق',
			NO_RECORD_FOUND: 'لم يتم العثور على سجلات',
			NEXT: 'التالي',
			SEARCH: 'بحث',
			IN_ALL_FIELDS: 'في جميع الحقول',
			LOADING: 'جاري التحميل ...',
			FORM_ERROR: 'قم بتغيير بعض الحقول وحاول مرة أخرى',
			ID:'المعرف',
			SELECT:'اختر',
			SELECT_ALL:'اختر الكل',
			UN_SELECT_ALL:'إلغاء إختيار الكل',
			CREATED_AT:'وقت الإنشاء',
			SHIFT_NOT_CLOSED:"غير مغلقة",
			TOTAL:"العدد الإجمالي",
			DATE_FROM: 'من تاريخ',
			DATE_TO: 'إلى تاريخ',
			DISABLE: 'تفعيل',
			ENABLE: 'تعطيل',
			ALL: 'الكل',
			ACTION: 'الإجراء',
			ENTER: 'دخول',
			EXIT: 'خروج',
			NA: 'غير محدد',
			PROCESSING: 'جاري المعالجة...',
		},
		USER_MANAGEMENT:{
			USER_LIST_TITLE:'قائمة المستخدمين',
			USER_EDIT_TITLE:'تعديل المستخدم',
			USER_CREATE_TITLE:'إنشاء مستخدم',
			TITLE: 'إدارة المستخدمين',
			FULL_NAME: 'الاسم كامل',
			MOBILE: 'الهاتف الخلوي',
			EMPLOYEE_NUMBER: 'رقم الموظف',
			ROLE: 'الدور',
			DRIVER_COMPANY: 'شركة السائق',
			CASHIER_AREA: 'منطقة الكاشير',
			BLOCKED: 'محجوب',
			BLOCK_REASON: 'سبب الحجب',
			ACTIONS: 'الاجراءات',
			PASSWORD: 'كلمة المرور',
			EMPLOYEE_NUMBER_OR_MOBILE: 'الرجاء إدخال رقم الموظف أو رقم الجوال',
		},
		REPORTS:{
			TITLE:'التقارير',
            RECENT_CARS:{
				TITLE:'أخر السيارات',
			},
			RECENT_DRIVERS:{
				TITLE:'أخر السائقين',
			}
		},
		MATTABLE:{
			FILTER: 'بحث',
			FILTER_EXAMPLE: 'مثال: محمد',
		},
		CASHIER:{
			TITLE:'كاشير',
			SIGNOUT:{
				AMOUNT: 'المبلغ',
				AMOUNT_DESC: 'رجاء أدخل مجموع المبلغ الذي قمت بتحصيله اليوم'
			},
			WAITING:{
				REFRESH:'تحديث',
				NO_CARS_AT_MOMENT:'لا يوجد سيارات في هذه اللحظة',
				PAY_MANUALLY:'دفع يدوي',
				AUTO_REFRESH_ENABLED:'البحث التلقائي فعال',
				AUTO_REFRESH_DESABLED:'البحث التلقائي معطل',
			},
			MANUALLY:{
				DRIVER_INFORMATION:'بيانات السائق',
				MOBILE_PHONE:'الهاتف الخلوي',
				MOBILE_PHONE_HINT:"رقم الهاتف الخلوي يجب أن يبدأ برقم 5 ويتكون من 9 خانات",
				NEXT:'التالي',
				SEND:'ارسل',
			},
			DRIVER:{
				DRIVER_INFORMATION:'بيانات السائق',
				MOBILE_PHONE:'الهاتف الخلوي',
				FULL_NAME:'الاسم كامل',
				NAME:'اسم السائق',
				COMPANY_INFORMATION:'بيانات الشركة',
				COMPANY_NAME:'اسم الشركة',
				COMPANY_BALANCE:'رصيد الشركة',
				CAR_INFORMATION:'بيانات السيارة',
				SELECT_CAR:'اختر سيارة',
				PLATE_NUMBER:'Plate Number',
				CAR_TYPE:'نوع السيارة',
				CAR_NAME:'اسم السيارة',
				BACK:'رجوع',
				PAY_CASH:'دفع يدوي',
				COMPANY_PAY:'دفع الشركة',
				PAY_DRIVER_BALANCE:'الدفع من رصيد السائق',
				AMOUNT:'المبلغ للدفع',
				CAR_MODEL: 'موديل السيارة',
				CAR_MODEL_YEAR: 'سنة إصدار السيارة',
				CAR_COLOR: 'لون السيارة',
				TICKET_FEES: 'رسوم التذكرة',

			},
			COMPANY:{
				DRIVER_INFORMATION:'بيانات السائق',
				MOBILE_PHONE:'الهاتف الخلوي',
				FULL_NAME:'الاسم كامل',
				COMPANY_INFORMATION:'بيانات الشركة',
				COMPANY_NAME:'اسم الشركة',
				COMPANY_BALANCE:'رصيد الشركة',
				CAR_INFORMATION:'بيانات السيارة',
				SELECT_CAR:'اختر سيارة',
				PLATE_NUMBER:'Plate Number',
				CAR_TYPE:'نوع السيارة',
				CAR_NAME:'اسم السيارة',
				BACK:'رجوع',
				PAY_CASH:'دفع يدوي',
				COMPANY_PAY:'دفع الشركة',
				PAY_DRIVER_BALANCE:'الدفع من رصيد السائق',
				DRIVER_NAME:'اسم السائق',
				TICKET_FEES: 'رسوم التذكرة',
			},
		},
		DIALOG:{
			SUCCESS:'نجاح!',
			ERROR:'خطأ!',
			INFO:'انتبه!',
			CONFIRM:'تأكيد',
			SUCCESS_MESSAGE:'العملية اكتملت بنجاح...',
			ERROR_MESSAGE:'لم تكتمل العملية بنجاح...',
			CONFIRM_MESSAGE:'هل انت متأكد؟',
			INFO_MESSAGE:'انتبه...',
			WAIT_MESSAGE:'تحميل...',
			OK:'موافق',
			CANCEL:'إلغاء',
			REMOVE_CAR:'حذف السيارة من المسار',
			COMPLETE_CAR:'إكمال الطلب',
			CAR_OPTION:'خيارات السيارة',
		},
		DRIVER:{
			BALANCE:{
				TITLE: 'الرصيد',
				CURRENT_BALANCE: 'الرصيد الحالي',
				QUICK_ACTIONS: 'إجراءات سريعة',
				TOP_UP_BALANCE: 'شحن الرصيد',
				VIEW_TRANSACTIONS: 'عرض المعاملات',
				RECENT_TRANSACTIONS: 'المعاملات الأخيرة',
				NO_TRANSACTIONS: 'لا توجد معاملات'
			},
			CHECKOUT:{
				TITLE: 'شحن الرصيد',
				PAYMENT_METHOD: 'طريقة الدفع',
				AMOUNT: 'المبلغ (ريال)',
				FIRST_NAME: 'الاسم الأول',
				LAST_NAME: 'اسم العائلة',
				EMAIL: 'البريد الإلكتروني',
				STREET_ADDRESS: 'عنوان الشارع',
				PROCEED_TO_PAYMENT: 'المتابعة للدفع',
				PROCESSING: 'جاري المعالجة...',
				LOADING_PAYMENT_WIDGET: 'جاري تحميل نموذج الدفع...',
				PROCESSING_PAYMENT: 'جاري معالجة الدفع...',
				REQUIRED_FIELD: 'هذا الحقل مطلوب',
				VALID_AMOUNT: 'مبلغ صحيح مطلوب (الحد الأدنى 1 ريال)',
				VALID_EMAIL: 'بريد إلكتروني صحيح مطلوب',
				WIDGET_ERROR: 'فشل تحميل نموذج الدفع. يرجى المحاولة مرة أخرى.',
				VERIFY_ERROR_TITLE: 'فشل التحقق من الدفع',
				VERIFY_ERROR_DEFAULT: 'تعذر التحقق من الدفع. يرجى المحاولة مرة أخرى أو التواصل مع الدعم.',
				TRY_AGAIN: 'إعادة المحاولة',
				BACK_TO_BALANCE: 'العودة للرصيد'
			},
			TRANSACTIONS:{
				TITLE: 'سجل المعاملات',
				TABLE: {
					DATE: 'التاريخ',
					TYPE: 'نوع الحركة',
					AMOUNT: 'المبلغ',
					DESCRIPTION: 'الوصف',
					ADDED_BY: 'أضيف بواسطة'
				},
				TYPES: {
					CASH_TOPUP: 'شحن نقدي',
					CASH_WITHDRAWAL: 'سحب نقدي',
					ONLINE_TOPUP: 'شحن إلكتروني',
					BALANCE_PAYMENT: 'دفع من الرصيد',
					BALANCE_REFUND: 'استرداد الرصيد'
				},
				NO_TRANSACTIONS: 'لا توجد معاملات',
				LOADING: 'جاري تحميل المعاملات...'
			}
		},
		ADMIN: {
			DRIVER_BALANCE: {
				TITLE: 'إدارة رصيد السائق',
				CURRENT_BALANCE: 'الرصيد الحالي',
				ACTIONS: 'الإجراءات',
				ADD_CASH_TOPUP: 'إضافة رصيد نقدي',
				WITHDRAW_CASH: 'سحب رصيد نقدي',
				VIEW_TRANSACTIONS: 'عرض المعاملات',
				AMOUNT: 'المبلغ',
				ADD_TOPUP: 'إضافة رصيد',
				WITHDRAW_AMOUNT: 'سحب المبلغ',
				AVAILABLE_BALANCE: 'الرصيد المتاح',
				ADDING_BALANCE: 'إضافة رصيد',
				ADDING_BALANCE_DESC: 'أدخل المبلغ الذي تريد إضافته إلى رصيد السائق.',
				WITHDRAWING_BALANCE: 'سحب رصيد',
				WITHDRAWING_BALANCE_DESC: 'أدخل المبلغ المراد سحبه. الرصيد المتاح:',
				ENTER_POSITIVE_AMOUNT: 'أدخل المبلغ للإضافة (مثال: 100.00)',
				ENTER_WITHDRAWAL_AMOUNT: 'أدخل المبلغ للسحب (مثال: 50.00)',
				VALIDATION: {
					AMOUNT_REQUIRED: 'المبلغ مطلوب',
					ZERO_NOT_ALLOWED: 'المبلغ لا يمكن أن يكون صفراً',
					MIN_AMOUNT: 'الحد الأدنى للمبلغ هو 0.01 ريال',
					INSUFFICIENT_BALANCE: 'الرصيد غير كافٍ. الرصيد المتاح أقل من المبلغ المراد سحبه'
				},
				MESSAGES: {
					TOPUP_SUCCESS: 'تم إضافة {{amount}} ريال بنجاح',
					WITHDRAWAL_SUCCESS: 'تم سحب {{amount}} ريال بنجاح',
					TOPUP_ERROR: 'حدث خطأ أثناء إضافة الرصيد',
					WITHDRAWAL_ERROR: 'حدث خطأ أثناء سحب الرصيد'
				},
				TRANSACTIONS: {
					TITLE: 'معاملات رصيد السائق',
					TABLE: {
						DATE: 'التاريخ',
						TYPE: 'نوع الحركة',
						AMOUNT: 'المبلغ',
						DESCRIPTION: 'الوصف',
						ADDED_BY: 'أضيف بواسطة'
					},
					NO_TRANSACTIONS: 'لا توجد معاملات',
					LOADING: 'جاري تحميل المعاملات...'
				},
				TYPES: {
					CASH_TOPUP: 'شحن نقدي',
					CASH_WITHDRAWAL: 'سحب نقدي',
					ONLINE_TOPUP: 'شحن إلكتروني',
					BALANCE_PAYMENT: 'دفع من الرصيد',
					BALANCE_REFUND: 'استرداد الرصيد'
				}
			}
		}
	}
};
